import PropTypes from "prop-types"
import { StackView } from "@planningcenter/tapestry-react"

const PaneFooter = ({ className, children, ...props }) => {
  return (
    <StackView
      alignment={"center" || props.alignment}
      axis={"horizontal" || props.axis}
      className={className ? className : ""}
      distribution={props.distribution}
      {...props}
    >
      {children}
    </StackView>
  )
}

PaneFooter.propTypes = {
  alignment: PropTypes.string,
  axis: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  distribution: PropTypes.string
}

export default PaneFooter
